import Http from "../http";
import {
  Transaction,
  Contract,
  Scheme,
  SchemeType,
  Order,
  Payment,
  UserWealth,
  Pagination
} from "../models/defi";

export interface SchemeAction {
  getSchemes: () => Promise<Scheme[]>;
  getSchemeDetail: (id: string) => Promise<Scheme>;
  getContracts: (query: { status?: string }) => Promise<Contract[]>;
  getContractDetail: (id: string) => Promise<Contract>;
  getContractsOfScheme: (id: string) => Promise<Contract[]>;
}

export default function(http: Http) {
  return {
    getActionsBySchemeType(type: SchemeType): SchemeAction {
      return {
        getSchemes: () => http.get(`/defi/${type}/schemes`),
        getSchemeDetail: id => http.get(`/defi/${type}/schemes/${id}`),
        getContracts: query =>
          http.get(`/defi/${type}/user/contracts`, { params: query }),
        getContractDetail: id => http.get(`/defi/${type}/contracts/${id}`),
        getContractsOfScheme: id =>
          http.get(`/defi/${type}/schemes/${id}/contracts`)
      };
    },

    getDebitSchemes() {
      return http.get("/defi/debit/schemes");
    },

    getDebitSchemeDetail(id: string) {
      return http.get(`/defi/debit/schemes/${id}`);
    },

    putOrder(data: {
      scheme_id: string | number;
      quantity: number;
      comment?: string;
      asset_id?: string;
    }): Promise<Order> {
      return http.post("/defi/orders", { data });
    },

    getOrder(id: string): Promise<Order> {
      return http.get(`/defi/orders/${id}`);
    },

    getOrders(query?: Pagination): Promise<Order[]> {
      return http.get("/defi/user/orders", { params: query });
    },

    cancelOrder(id: string): Promise<Order> {
      return http.put(`/defi/orders/${id}/cancel`);
    },

    requestPayOrder(id: string): Promise<Payment> {
      return http.post(`/defi/orders/${id}/pay_requests`);
    },

    getTransitions(query?: Pagination): Promise<Transaction[]> {
      return http.get("/defi/user/transactions", { params: query });
    },

    getTransitionDetail(id: string): Promise<Transaction> {
      return http.get(`/defi/user/transactions/${id}`);
    },

    getTransitionDetailByTraceId(id: string): Promise<Transaction> {
      return http.get(`/defi/user/transaction/traceid/${id}`);
    },

    getWealthes(): Promise<UserWealth> {
      return http.get("/defi/user/wealths");
    },

    requestWithdraw(
      id: string,
      data: { quantity?: number | string; comment?: string }
    ) {
      return http.post(`/defi/contracts/${id}/withdraw_requests`, { data });
    },

    getTransactionByTraceId(id: string): Promise<Transaction> {
      return http.get(`/defi/user/transaction/traceid/${id}`);
    },

    getCustomerService() {
      return http.get("/defi/customer-service");
    },

    getBoxDecomposeConversation() {
      return http.get("/conversations/box");
    },

    getLoanConversation() {
      return http.get("/conversations/loan");
    }
  };
}
